import {
  ConsoleLogger,
  BackgroundBlurVideoFrameProcessor,
  DefaultVideoTransformDevice,
  VideoFrameProcessor,
  VideoInputDevice
} from "amazon-chime-sdk-js";

const getBlurDevice = async (
  videoInput: MediaDeviceInfo | null,
  logger: ConsoleLogger
): Promise<VideoInputDevice | null> => {
  // Create blur device if blur video frame processor is supported and video input is not null
  const processors: VideoFrameProcessor[] = [];
  const isBlurVideoFrameProcessorSupported = await BackgroundBlurVideoFrameProcessor.isSupported();
  let blurDevice: VideoInputDevice | null = null;
  if (isBlurVideoFrameProcessorSupported && videoInput) {
    const blurProcessor = await BackgroundBlurVideoFrameProcessor.create();
    if (blurProcessor) {
      processors.push(blurProcessor);
      blurDevice = new DefaultVideoTransformDevice(
        logger,
        videoInput,
        processors
      );
    }
  }
  return blurDevice;
};

export const getVideoInputDevice = async (
  videoInput: MediaDeviceInfo | null,
  isBlurVideo: boolean,
  logger: ConsoleLogger
): Promise<VideoInputDevice | null> => {
  let videoInputDevice: VideoInputDevice | null = videoInput;
  if (isBlurVideo) {
    const blurVideoInputDevice: VideoInputDevice | null = await getBlurDevice(
      videoInput,
      logger
    );
    if (blurVideoInputDevice) {
      videoInputDevice = blurVideoInputDevice;
    }
  }
  return videoInputDevice;
};
